<template>
  <div class="actions-panel">
    <div class="border-buttons">
      <div class="border-button">
        <vbutton
          v-if="linkToXls"
          label="invites.invite.downloadXLSExample"
          color="transparent"
          text_color="grey"
          icon="icon_arrow_down"
          @click="download_xls"
        />
      </div>

      <div class="border-button">
        <vbutton
          label="invites.invite.importFromExcel"
          color="transparent"
          text_color="grey"
          icon="icon_xls"
          @click="$emit('show-xls-import-modal')"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InvitesCreationActions',

    computed: {
      currentLocale() {
        return this.$store.state.locale.value;
      },

      linkToXls() {
        if (this.currentLocale === 'ru') {
          return 'https://vcv-files.s3.amazonaws.com/send_interview_example.xls';
        } else if (this.currentLocale === 'ja' || this.currentLocale === 'jp') {
          return 'https://vcv-files.s3-eu-west-1.amazonaws.com/send_interview_example_JP.xlsx';
        }

        return 'https://vcv-files.s3.amazonaws.com/send_interview_example_EN.xls';
      }
    },

    methods: {
      download_xls() {
        window.location = this.linkToXls;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .border-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .border-button {
      position: relative;
      padding-right: 1px;

      &:before {
        content: '';
        position: absolute;
        width: 1px;
        height: 30px;
        top: 5px;
        bottom: 5px;
        left: -1px;
        background: #d3d6da;
      }

      &:hover:not(.disabled) {
        &:before {
          display: none;
        }

        & + .border-button:before {
          display: none;
        }
      }

      &:first-child {
        &:before {
          display: none;
        }
      }
    }
  }
</style>
